import { getCurrentSitePublicId } from './siteSession';

const NO_SITE_SCOPE = 'no-site';

/**
 * 浏览器持久化数据必须包含 Site 作用域，避免相同业务 ID 在不同 Site 之间
 * 复用草稿、筛选条件或编辑器状态。
 */
export const getSiteScopedStorageKey = (
  prefix: string,
  resourceId?: string | number,
): string => {
  const siteScope = encodeURIComponent(getCurrentSitePublicId() ?? NO_SITE_SCOPE);
  const resourceScope = resourceId === undefined ? '' : `:${encodeURIComponent(String(resourceId))}`;
  return `${prefix}:site:${siteScope}${resourceScope}`;
};
